/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Accolade
 */
export interface Accolade {
    /**
     * 
     * @type {Date}
     * @memberof Accolade
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Accolade
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof Accolade
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Accolade
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Accolade
     */
    primaryColor: string;
    /**
     * 
     * @type {number}
     * @memberof Accolade
     */
    priority: number;
    /**
     * 
     * @type {string}
     * @memberof Accolade
     */
    secondaryColor: string;
    /**
     * 
     * @type {string}
     * @memberof Accolade
     */
    shortName: string;
    /**
     * 
     * @type {Date}
     * @memberof Accolade
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the Accolade interface.
 */
export function instanceOfAccolade(value: object): value is Accolade {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('primaryColor' in value) || value['primaryColor'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('secondaryColor' in value) || value['secondaryColor'] === undefined) return false;
    if (!('shortName' in value) || value['shortName'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function AccoladeFromJSON(json: any): Accolade {
    return AccoladeFromJSONTyped(json, false);
}

export function AccoladeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Accolade {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['created_at'])),
        'description': json['description'],
        'id': json['id'],
        'name': json['name'],
        'primaryColor': json['primary_color'],
        'priority': json['priority'],
        'secondaryColor': json['secondary_color'],
        'shortName': json['short_name'],
        'updatedAt': (new Date(json['updated_at'])),
    };
}

export function AccoladeToJSON(json: any): Accolade {
    return AccoladeToJSONTyped(json, false);
}

export function AccoladeToJSONTyped(value?: Accolade | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created_at': value['createdAt'].toISOString(),
        'description': value['description'],
        'id': value['id'],
        'name': value['name'],
        'primary_color': value['primaryColor'],
        'priority': value['priority'],
        'secondary_color': value['secondaryColor'],
        'short_name': value['shortName'],
        'updated_at': value['updatedAt'].toISOString(),
    };
}

